import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["button", "content"]

  connect() {
    let active = this.buttonTargets.find(el => { return el.closest("li").classList.contains("is-active") })
    if (active) {
      this.updateTab(active)
    }
  }

  update(e) {
    // ensures the update action works regardless what element is clicked on inside the link
    let button = (e.target.tagName === "a") ? e.target : e.target.closest("a")

    this.updateTab(button)
  }

  updateTab(button) {
    this.buttonTargets.forEach(el => {
      if (el === button) {
        el.closest("li").classList.add("is-active")
      } else {
        el.closest("li").classList.remove("is-active")
      }
    })

    this.contentTargets.forEach(el => {
      if (el.dataset["content"] === button.dataset["tabFor"]) {
        el.classList.remove("is-hidden")
      } else {
        el.classList.add("is-hidden")
      }
    })
  }
}
